import { createStore } from 'vuex'
import router from '@/router'
import { getToken, setToken } from '../unit/auth'
import { login,byNameLogin } from '../api/user.js'

const store = createStore({
    state: {
        tokenKey: getToken(),
        nickname: null,
        username: null,
        phone: null,
        roleList: [],
        permissionList: [],
        orgName: null,
        orgId: null,
        logoPath: localStorage.getItem('logoPath'),
        storeCode: null,
        msgCount: localStorage.getItem('msgCount') == 0 || localStorage.getItem('msgCount') == null || localStorage.getItem('msgCount') == undefined || localStorage.getItem('msgCount') === "undefined" ? '' : localStorage.getItem('msgCount'),
        menuactive: '2-2',
        tabs: [
            { menuactive: '2-2', title: '销售单跟进', path: 'orderfollowup' },
            // { menuactive: '2-1', title: '新建销售单', path: 'neworder' },
        ],
        shortcuts: [
            {
                text: '全部',
                value: () => {
                    const end = new Date()
                    const start = new Date('2023-01-01')
                    start.setTime(start.getTime())
                    return [start, end]
                },
            },
            {
                text: '昨天',
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                    return [start, end]
                },
            },
            {
                text: '本月',
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    let y = start.getFullYear()
                    let m = start.getMonth() + 1
                    let startTime = y + '-' + m + '-01'
                    return [startTime, end]
                },
            },
            {
                text: '上个月',
                value: () => {
                    const time = new Date()
                    let y = time.getFullYear()
                    let sm = time.getMonth()
                    const end = new Date((time.getFullYear()) + '-' + (time.getMonth() + 1) + '-01')
                    let em = end.getMonth() + 1
                    let ed = end.getDate() - 1
                    let startTime = y + '-' + sm + '-01'
                    let endTime = y + '-' + em + '-' + ed
                    return [startTime, endTime]
                },
            },
            {
                text: '最近一周',
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    return [start, end]
                },
            },
            {
                text: '最近一个月',
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    return [start, end]
                },
            },
            {
                text: '最近三个月',
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    return [start, end]
                },
            },
        ],
        isPaytype: false,
    },

    mutations: {
        loginSet(state, loginInfo) {
            console.log(loginInfo)
            state.nickname = loginInfo.nickname
            state.username = loginInfo.username
            state.phone = loginInfo.phone
            state.roleList = loginInfo.roleList
            state.permissionList = loginInfo.permissionList
            state.logoPath = loginInfo.logoPath
            state.orgName = loginInfo.orgName
            state.orgId = loginInfo.orgId
            state.storeCode = loginInfo.storeCode
            state.msgCount = loginInfo.msgCount == 0 || loginInfo.msgCount == '' || loginInfo.msgCount == undefined ? '' : loginInfo.msgCount
        },
        logout(state){
            state.tabs= [
                { menuactive: '2-2', title: '销售单跟进', path: 'orderfollowup' }
            ]
            state.menuactive = '2-2'
            // localStorage.removeItem('t-ui:TTable.columnSet-orderfollowup')
            // localStorage.removeItem('t-ui:TTable.columnSet-designfollowup')
            // localStorage.removeItem('t-ui:TTable.columnSet-supplierfollowup')
            // localStorage.removeItem('t-ui:TTable.columnSet-suppdigitaldepartment')
            // localStorage.removeItem('t-ui:TTable.columnSet-logisticsfollowup')
        },
        setMenactive(state, data) {
            state.menuactive = data
        },
        addTab(state, data) {
            state.tabs.push(data)
        },
        setmenuactive(state,data){
            state.menuactive = data
        },
        removeTab(state, data) {
            if (data.routename == data.path) {
                let routePath = state.tabs[data.index - 1].path
                let menuactive = state.tabs[data.index - 1].menuactive
                state.menuactive = menuactive
                router.push({ path: '/' + routePath })
                state.tabs.splice(data.index, 1)
            } else {
                state.tabs.splice(data.index, 1)
            }
        },
        //清除当前tab页并跳转当前关闭的前一个tab
        deltabs(state, data) {
            let index = state.tabs.findIndex(item => item.path == data)
            state.tabs.splice(index, 1)
            if (data == "neworder") {
                let flag = true
                state.tabs.forEach(item => {
                    if (item.path == "orderfollowup") {
                        flag = false
                    }
                })
                if (flag) {
                    state.tabs.push({ menuactive: '2-2', title: '销售单跟进', path: 'orderfollowup' })
                    router.push({ path: 'orderfollowup' })
                    state.menuactive = '2-2'
                } else {
                    router.push({ path: 'orderfollowup' })
                    state.menuactive = '2-2'
                }
            }

            if (data == "newdesign") {
                let flag = true
                state.tabs.forEach(item => {
                    if (item.path == "designfollowup") {
                        flag = false
                    }
                })
                if (flag) {
                    state.tabs.push({ menuactive: '3-2', title: '设计单跟进', path: 'designfollowup' })
                    router.push({ path: 'designfollowup' })
                    state.menuactive = '3-2'
                } else {
                    router.push({ path: 'designfollowup' })
                    state.menuactive = '3-2'
                }
                // router.push({ path: 'designfollowup' })
                // state.menuactive = '3-2'
            }

            if (data == "newsupplier") {
                let flag = true
                state.tabs.forEach(item => {
                    if (item.path == "supplierfollowup") {
                        flag = false
                    }
                })
                if (flag) {
                    state.tabs.push({ menuactive: '3-2', title: '生产单跟进', path: 'supplierfollowup' })
                    router.push({ path: 'supplierfollowup' })
                    state.menuactive = '4-2'
                } else {
                    router.push({ path: 'supplierfollowup' })
                    state.menuactive = '4-2'
                }
            }
        },
        keepCurrent(state){
            console.log(state.menuactive)
            let arr = []
            let index = state.tabs.findIndex(item => item.menuactive == state.menuactive)
            if(index==0){
                arr.push(state.tabs[0])
            }else{
                arr.push(state.tabs[0])
                arr.push(state.tabs[index])
            }
            state.tabs = arr
        },
        removeAll(state){
            state.tabs= [
                { menuactive: '2-2', title: '销售单跟进', path: 'orderfollowup' }
            ]
            state.menuactive = '2-2'
            router.push({path:'/orderfollowup'})
        },
        stompMessage(state, data) {
            state.isPaytype = true
        },
        stompMsgCount(state,data){
            console.log('未读消息')
            state.msgCount = data
            localStorage.setItem('msgCount',data)
        },
        setMessage(state, data) {
            state.msgCount = data == 0 || data == null || data == undefined ? '' : data
        }
    },

    actions: {
        login(store, loginInfo) {
            const { username, password } = loginInfo
            return new Promise((resolve, reject) => {
                // login({ userName: username.trim(), password: password })
                byNameLogin({ userName: username.trim(), password: password })
                    .then(response => {
                        const res = response
                        console.log(res)
                        store.commit('loginSet', res.data)
                        setToken(res.data.token)
                        localStorage.setItem('orgId', res.data.orgId)
                        localStorage.setItem('orgName', res.data.orgName) //公司标识
                        localStorage.setItem('storeCode', res.data.storeCode) //门店编号
                        localStorage.setItem('logoPath', res.data.logoPath) //公司logo
                        localStorage.setItem('domain', res.data.domain) //公司标识
                        localStorage.setItem('nickName', res.data.nickname) //用户昵称
                        localStorage.setItem('userName', res.data.userName) //用户名
                        localStorage.setItem('phone', res.data.phone) //联系电话
                        localStorage.setItem('state', res.data.state) //账户状态是否可用
                        localStorage.setItem('permissionList', res.data.permissionList) //菜单权限
                        localStorage.setItem('operatorId', res.data.operatorId) //操作员ID
                        localStorage.setItem('saleManCode', res.data.saleManCode) //操作员CODE
                        localStorage.setItem('msgCount', res.data.msgCount) //未读消息数量

                        // localStorage.setItem('code', res.data.code)
                        // localStorage.setItem('userPost',res.data)//用户岗位信息
                        // localStorage.setItem('userInfo',res.data)//用户信息
                        resolve(res)
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                        return Promise.reject(err)
                    })
            })
        },

        //store) {
        //     // console.log(store.state.name)
        //     const username = getToken()
        //     return new Promise((resolve, reject) => {
        //         getuser(username)
        //             .then(response => {
        //                 const res = response.data
        //                 console.log(res)
        //                     // store.commit('setUserInfo', res)
        //                 resolve()
        //             }).catch(err => {
        //                 console.log(err)
        //                 reject(err)
        //                 return Promise.reject(err)
        //             })
        //     })
        // },

    }
})

export default store